import { animate, stagger } from '../../vendor/anime.esm.js';
import { DURATION, EASE, STAGGER, resolveDuration, resolveStagger } from '../motion-tokens.js';

/**
 * Animaciones de entrada de los bloques de Track C: form · menu · services.
 *
 * Mismo patrón que process/features: se FUERZA el estado inicial (opacity 0 +
 * desplazamiento) ANTES de que el orquestador añada `anime-init` y revele la
 * sección — así no hay flash del contenido completo antes del stagger. Solo
 * fade + desplazamiento (sin split-text/clipPath) → seguro en motion 'reduced'
 * y cross-browser (no dependemos del scroll-timeline CSS, que falta en
 * Firefox/Safari viejos; ahí estos bloques quedaban sin stagger).
 *
 * Registradas con clave SIN variante en variant-animations.js (lookup cae de
 * 'menu-v1' → 'menu'), así v1 y v2 comparten coreografía. DRY.
 */

// ── SERVICES — tarjetas (v1) o filas (v2) entran con stagger ──
export const servicesAnim = (el) => {
    const cards = el.querySelectorAll('.service-card');
    if (!cards.length) return null;
    // v2 son filas horizontales → entran deslizando desde la izquierda;
    // v1 son tarjetas → suben con un leve zoom.
    const isRow = el.querySelector('.service-row') !== null;

    cards.forEach(c => {
        c.style.opacity = '0';
        c.style.transform = isRow ? 'translateX(-24px)' : 'translateY(26px) scale(0.95)';
        c.style.filter = 'blur(3px)';
    });

    animate(cards, {
        opacity:    [0, 1],
        translateX: isRow ? [-24, 0] : [0, 0],
        translateY: isRow ? [0, 0] : [26, 0],
        scale:      isRow ? [1, 1] : [0.95, 1],
        filter:     ['blur(3px)', 'blur(0px)'],
        delay:      stagger(resolveStagger(STAGGER.normal)),
        duration:   resolveDuration(DURATION.slow),
        ease:       EASE.snappy,
    });
    return null;
};

// ── MENU — las categorías entran y sus platos caen en cascada fina ──
export const menuAnim = (el) => {
    const cats   = el.querySelectorAll('.menu-category');
    const dishes = el.querySelectorAll('.menu-dish');
    if (!cats.length) return null;

    cats.forEach(c => { c.style.opacity = '0'; c.style.transform = 'translateY(24px)'; c.style.filter = 'blur(3px)'; });
    dishes.forEach(d => { d.style.opacity = '0'; d.style.transform = 'translateY(12px)'; });

    // Primario: bloques de categoría
    animate(cats, {
        opacity:    [0, 1],
        translateY: [24, 0],
        filter:     ['blur(3px)', 'blur(0px)'],
        delay:      stagger(resolveStagger(STAGGER.normal)),
        duration:   resolveDuration(DURATION.normal),
        ease:       EASE.refined,
    });
    // Secundario: platos (nombre · líder de puntos · precio) en cascada
    animate(dishes, {
        opacity:    [0, 1],
        translateY: [12, 0],
        delay:      stagger(resolveStagger(40), { start: 120 }),
        duration:   resolveDuration(DURATION.normal),
        ease:       EASE.snappy,
    });
    return null;
};

// ── FORM — los campos entran con stagger; el botón remata con un pop ──
export const formAnim = (el) => {
    const fields = el.querySelectorAll('.form-field');
    const submit = el.querySelector('.form-submit');
    if (!fields.length) return null;

    fields.forEach(f => { f.style.opacity = '0'; f.style.transform = 'translateY(20px)'; });

    animate(fields, {
        opacity:    [0, 1],
        translateY: [20, 0],
        delay:      stagger(resolveStagger(STAGGER.normal)),
        duration:   resolveDuration(DURATION.normal),
        ease:       EASE.refined,
    });
    if (submit) {
        submit.style.opacity = '0';
        animate(submit, {
            opacity:    [0, 1],
            scale:      [0.9, 1],
            translateY: [12, 0],
            delay:      resolveDuration(DURATION.normal) * 0.6,
            duration:   resolveDuration(DURATION.fast),
            ease:       EASE.snappy,
        });
    }
    return null;
};
